import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ImageWithBasePath from "../core/img/imagewithbasebath";
import { loginWithEmail } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const CelebLoginEmailOtp = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [credentials, setCredentials] = useState({
        userEmail: '',
        userPassword: ''
    });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    useEffect(() => {
        document.body.classList.add("account-page");
        return () => document.body.classList.remove("account-page");
    }, []);

    // Pre-fill email if coming from registration
    useEffect(() => {
        if (location.state?.preFilledEmail) {
            setCredentials(prev => ({
                ...prev,
                userEmail: location.state.preFilledEmail
            }));
        }
    }, [location.state]);

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await loginWithEmail(credentials);
            console.log('CELEB EMAIL LOGIN RESPONSE:', response);

            if (response.success) {
                navigate('/celeb-email-otp-verify', {
                    state: {
                        userEmail: credentials.userEmail,
                        userPassword: credentials.userPassword
                    }
                });
            }
        } catch (err) {
            setError(err.message || 'Failed to send OTP. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handlePhoneLogin = () => {
        navigate('/celebrity-login');
    };

    return (
        <>
            <Navbar {...props} />
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="account-content">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-7 col-lg-6 login-left">
                                    <ImageWithBasePath
                                            src="assets/img/Artboard7.svg"
                                        className="img-fluid"
                                        alt="Howzit! Login"
                                    />
                                </div>
                                <div className="col-md-12 col-lg-6 login-right">
                                    <div className="login-header">
                                        <h3>Sign in with Email <span>howzit! Dashboard</span></h3>
                                        <p>We'll send a confirmation code to your email.</p>
                                        {location.state?.preFilledEmail && (
                                            <div className="alert alert-info mt-3">
                                                <small>Registration successful! Please enter your password to receive OTP.</small>
                                            </div>
                                        )}
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger mb-4">
                                            <div className="d-flex align-items-center">
                                                <i className="fas fa-exclamation-triangle me-2"></i>
                                                <div>
                                                    <strong>Error!</strong>
                                                    <div className="small">{error}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Email Address</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="userEmail"
                                                value={credentials.userEmail}
                                                onChange={handleChange}
                                                placeholder="your@email.com"
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="form-group-flex">
                                                <label className="form-label">Password</label>
                                                <Link to="/forgot-password2" className="forgot-link">
                                                    Forgot password?
                                                </Link>
                                            </div>
                                            <div className="pass-group" style={{ position: 'relative' }}>
                                                <input
                                                    type={isPasswordVisible ? "text" : "password"}
                                                    className="form-control pass-input-sub"
                                                    name="userPassword"
                                                    value={credentials.userPassword}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <span
                                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                                    style={{
                                                        position: 'absolute',
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        cursor: 'pointer',
                                                        color: '#6c757d',
                                                        fontSize: '16px',
                                                        zIndex: 10
                                                    }}
                                                >
                                                    {isPasswordVisible ? '🙈' : '👁️'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-primary-gradient w-100"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? 'Sending OTP...' : 'Send OTP'}
                                            </button>
                                        </div>

                                        <div className="login-or">
                                            <span className="or-line" />
                                            <span className="span-or">or</span>
                                        </div>

                                        <div className="mb-3 text-center">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary w-100"
                                                onClick={handlePhoneLogin}
                                            >
                                                Sign in with Phone
                                            </button>
                                        </div>

                                        <div className="account-signup">
                                            <p>
                                                Don't have an account? <Link to="/celeb-register">Sign up</Link>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default CelebLoginEmailOtp;